import { Component, inject } from '@angular/core';
import { getClubOption } from '@aaa/emember/store-membership';
import { Store } from '@ngrx/store';
import { AppStore } from '@aaa/emember/store-types';
import { AsyncPipe } from '@angular/common';
import { ButtonLinkComponent } from './ava-link/ava-link.component';
import { ClubApp } from '@aaa/emember/types';

@Component({
  standalone: true,
  selector: 'ava-payment-ar-description',
  template: `
    <p class="text-base font-extralight">
      <span class="font-normal">
        By selecting auto renew, your AAA Membership is automatically renewed each year to the payment card you
        provided.
      </span>
      <br />
      You will receive an annual notice about 40 days prior to your renewal date, which notice will state the term of
      your next membership period and the total dues to be charged to your card. You can manage your account, update
      your card information, or cancel automatic renewal anytime at
      <ava-link
        class="text-base font-extralight"
        href="http://www.aaa.com/myaccount"
        label="AAA | American Automobile Association "
      />
      or by calling the number on the back of your membership card. With enrollment, you acknowledge and understand that
      any discounted membership rate is for a limited time.
      @if (clubOption$ | async; as option) {
        @if (option.clubId === ClubApp.SouthJersey) {
          <span>Your credit card will be charged approximately 15 days prior to your renewal date.</span>
        }
      }

      <br />
      <span class="font-normal">
        Check the box above to continue, or call

        @if (clubOption$ | async; as option) {
          <ava-link
            class="text-base font-extralight"
            href="tel:{{ option.phoneNumber }}"
            [label]="option.phoneNumberView"
          />
        }

        for more options.
      </span>
    </p>
  `,
  imports: [ButtonLinkComponent, AsyncPipe],
})
export class AvaPaymentArDescriptionComponent {
  protected readonly ClubApp = ClubApp;
  store = inject(Store<AppStore>);
  clubOption$ = this.store.select(getClubOption);
}
